const styles = `
  @keyframes slide-up {
    from {
      transform: translateY(100%);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
  
  .animate-slide-up {
    animation: slide-up 0.25s cubic-bezier(0.16, 1, 0.3, 1);
  }

  @keyframes heart-pop {
    0% { transform: scale(1); }
    50% { transform: scale(1.3); }
    100% { transform: scale(1); }
  }
  
  .animate-heart-pop {
    animation: heart-pop 0.3s ease-out;
  }

  @keyframes fade-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  
  .animate-fade-in {
    animation: fade-in 0.2s ease-out;
  }

  .comment-blur-overlay {
    backdrop-filter: blur(2px);
    -webkit-backdrop-filter: blur(2px);
  }

  .reply-fade-in {
    animation: fade-in 0.3s ease-in-out;
  }
`;

export const registerStyles = () => {
  if (
    typeof document !== "undefined" &&
    !document.getElementById("comments-modal-styles")
  ) {
    const styleSheet = document.createElement("style");
    styleSheet.innerText = styles;
    styleSheet.id = "comments-modal-styles";
    document.head.appendChild(styleSheet);
  }
};